export const authRoles = {
  admin: ['ADMIN'],
  user: ['USER']
}